import type { HTMLAttributes } from 'react'

import { cn } from '@/utils/cn'

export type BadgeTone = 'success' | 'progress' | 'attention' | 'critical' | 'idle' | 'neutral'

const TONES: Record<BadgeTone, string> = {
  success: 'bg-ok/12 text-ok',
  progress: 'bg-progress/12 text-progress',
  attention: 'bg-attention/15 text-[#8a6d05] dark:text-attention',
  critical: 'bg-critical/12 text-critical',
  idle: 'bg-idle/15 text-idle',
  neutral: 'bg-surface-2 text-fg-muted',
}

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

export function Badge({ tone = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONES[tone],
        className,
      )}
      {...props}
    />
  )
}

export function StatusBadge({ active }: { active: boolean }) {
  return <Badge tone={active ? 'success' : 'idle'}>{active ? 'Ativo' : 'Inativo'}</Badge>
}
